import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const StyledBox = styled(Box)(({ theme }) => ({
  '&.infoContentBody': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[500],
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '400',
    fontFamily: theme.typography.fontFamily,
    lineHeight: theme.spacing(3),
    '& p, & h2, & h3, & h4, & h5': {
      marginTop: 0,
    },
    '& a': {
      color: theme.palette.primary.main,
    },
  },
  '& .pageTitle': {
    color: theme.palette.grey[500],
    fontSize: theme.typography.pxToRem(28),
    marginBottom: theme.spacing(2),
    marginTop: 0,
    fontWeight: '700',
    lineHeight: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      // mobile
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.spacing(3.75),
    },
  },
  '& .paragraphTitle': {
    color: theme.palette.secondary.dark,
    fontSize: theme.typography.pxToRem(16),
    marginBottom: `${theme.spacing(1)} !important`,
    fontWeight: '500',
    lineHeight: theme.spacing(3.25),
    letterSpacing: 0.12,
  },
  '& .paragraphContainer': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    gap: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    '& p': {
      margin: 0,
    },
  },
  '& .hyperlink': {
    color: theme.palette.primary.main,
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '500',
    textDecoration: 'underline',
    lineHeight: theme.spacing(3),
  },
  '& ul.bulletsList': {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: '400',
    color: theme.palette.grey[500],
    marginTop: 0,
    paddingLeft: theme.spacing(3.5),
    '&.decimalList': {
      listStyleType: 'decimal',
    },
    '& .imgBox': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
  },
  '& .sectionContainer': {
    paddingBottom: theme.spacing(3),
  },
  '& .sectionTitle': {
    color: theme.palette.secondary.dark,
    marginBottom: theme.spacing(2),
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(26),
    fontWeight: 700,
    letterSpacing: 0.12,
  },
  '& .imgBox, & .videoBox': {
    padding: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.grey[50]}`,
    backgroundColor: '#FCFCFC',
    maxWidth: '100%',
    '& iframe, & video': {
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: '100%',
      },
    },
  },

  '& .alert': {
    padding: theme.spacing(1.75, 2),
    borderRadius: theme.spacing(1),
    gap: theme.spacing(1),
    display: 'flex',
    color: theme.palette.grey[500],
    alignItems: 'flex-start',
    width: 'fit-content',

    '& p': {
      margin: 0,
      padding: 0,
    },
    '&.errorAlert': {
      backgroundColor: 'rgba(244, 67, 54, 0.10)',
      '& path': {
        fill: theme.palette.error.main,
      },
    },
    '&.infoAlert': {
      backgroundColor: ' rgba(139, 208, 203, 0.10)',
      '& path': {
        fill: theme.palette.info.main,
      },
    },
    '&.warningAlert': {
      backgroundColor: ' rgba(243, 224, 94, 0.10)',
      '& path': {
        fill: theme.palette.warning.main,
      },
    },
    '&.successAlert': {
      backgroundColor: 'rgba(76, 175, 80, 0.10)',
      '& path': {
        fill: theme.palette.success.main,
      },
    },
  },
  '& .table': {
    borderCollapse: 'collapse',
    width: '100%',
    '& th, & td': {
      border: `1px solid ${theme.palette.grey[100]}`,
      padding: theme.spacing(1),
      letterSpacing: 0.12,
      textAlign: 'start',
    },
    '& th': {
      fontWeight: '500',
    },
  },
  '& .w-100': {
    width: '100%',
  },
  '& .underline': {
    textDecoration: 'underline',
  },

  // spacing
  '& .mb-2': {
    marginBottom: `${theme.spacing(2)} !important`,
  },
  '& .mt-2': {
    marginTop: theme.spacing(2),
  },
  '& .my-2': {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  '& .mb-3': {
    marginBottom: theme.spacing(3),
  },
  '& .mt-3': {
    marginTop: theme.spacing(3),
  },

}));

export default StyledBox;
